module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0)]) : _c('div', [(!_vm.loginIs) ? _c('vip-login', {
    attrs: {
      "pageZoom": _vm.pageZoom
    }
  }) : (_vm.loginIs && _vm.vipState === 0 && _vm.cvipMes) ? _c('vip-no', {
    attrs: {
      "pageZoom": _vm.pageZoom,
      "card-state": _vm.cardState,
      "vipState": _vm.vipState
    }
  }) : (_vm.loginIs && (_vm.vipState === 1 || _vm.vipState === 10) && _vm.cvipMes) ? _c('vip', {
    attrs: {
      "vipState": _vm.vipState,
      "card-state": _vm.cardState
    }
  }) : (_vm.loginIs && _vm.vipState === 2 && _vm.cvipMes) ? _c('vip-expir', {
    attrs: {
      "vipState": _vm.vipState
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "spinner-container container1"
  }, [_c('div', {
    staticClass: "circle1"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle2"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle3"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-container container2"
  }, [_c('div', {
    staticClass: "circle1"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle2"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle3"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-container container3"
  }, [_c('div', {
    staticClass: "circle1"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle2"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle3"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle4"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f9020a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/Index.vue
// module id = DWx1
// module chunks = 1